// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as BuyRouteImport } from './routes/buy'
import { Route as ContactsRouteImport } from './routes/contacts'
import { Route as FundRouteImport } from './routes/fund'
import { Route as MarketsRouteImport } from './routes/markets'
import { Route as NftsRouteImport } from './routes/nfts'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ReceiveRouteImport } from './routes/receive'
import { Route as RiskRouteImport } from './routes/risk'
import { Route as SecureRouteImport } from './routes/secure'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as SellRouteImport } from './routes/sell'
import { Route as SendRouteImport } from './routes/send'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SitemapDotxmlRouteImport } from './routes/sitemap[.]xml'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SwapRouteImport } from './routes/swap'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TrustlinesRouteImport } from './routes/trustlines'
import { Route as ApiPublicClientReportRouteImport } from './routes/api/public/client-report'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ActivityRoute = ActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => rootRouteImport
          })
const BuyRoute = BuyRouteImport.update({
            id: '/buy',path: '/buy',getParentRoute: () => rootRouteImport
          })
const ContactsRoute = ContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => rootRouteImport
          })
const FundRoute = FundRouteImport.update({
            id: '/fund',path: '/fund',getParentRoute: () => rootRouteImport
          })
const MarketsRoute = MarketsRouteImport.update({
            id: '/markets',path: '/markets',getParentRoute: () => rootRouteImport
          })
const NftsRoute = NftsRouteImport.update({
            id: '/nfts',path: '/nfts',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ReceiveRoute = ReceiveRouteImport.update({
            id: '/receive',path: '/receive',getParentRoute: () => rootRouteImport
          })
const RiskRoute = RiskRouteImport.update({
            id: '/risk',path: '/risk',getParentRoute: () => rootRouteImport
          })
const SecureRoute = SecureRouteImport.update({
            id: '/secure',path: '/secure',getParentRoute: () => rootRouteImport
          })
const SecurityRoute = SecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => rootRouteImport
          })
const SellRoute = SellRouteImport.update({
            id: '/sell',path: '/sell',getParentRoute: () => rootRouteImport
          })
const SendRoute = SendRouteImport.update({
            id: '/send',path: '/send',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const SitemapDotxmlRoute = SitemapDotxmlRouteImport.update({
            id: '/sitemap.xml',path: '/sitemap.xml',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const SwapRoute = SwapRouteImport.update({
            id: '/swap',path: '/swap',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TrustlinesRoute = TrustlinesRouteImport.update({
            id: '/trustlines',path: '/trustlines',getParentRoute: () => rootRouteImport
          })
const ApiPublicClientReportRoute = ApiPublicClientReportRouteImport.update({
            id: '/api/public/client-report',path: '/api/public/client-report',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ActivityRoute: ActivityRoute,BuyRoute: BuyRoute,ContactsRoute: ContactsRoute,FundRoute: FundRoute,MarketsRoute: MarketsRoute,NftsRoute: NftsRoute,PrivacyRoute: PrivacyRoute,ReceiveRoute: ReceiveRoute,RiskRoute: RiskRoute,SecureRoute: SecureRoute,SecurityRoute: SecurityRoute,SellRoute: SellRoute,SendRoute: SendRoute,SettingsRoute: SettingsRoute,SitemapDotxmlRoute: SitemapDotxmlRoute,SupportRoute: SupportRoute,SwapRoute: SwapRoute,TermsRoute: TermsRoute,TrustlinesRoute: TrustlinesRoute,ApiPublicClientReportRoute: ApiPublicClientReportRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)